import * as React from 'react'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import { Select } from '@workwave-tidal/core/components'
import FormHelperText from '@mui/material/FormHelperText'

import { useData, useHandlers } from './hooks'
import { SalesTeam } from '@user/store/salesTeam'

type Props = {
  name: string
  label: string
  disabled: boolean
  optionList: SalesTeam[]
  onChange: (value: SalesTeam | null) => void
  required?: boolean
  errorText?: string
}

export function SalesTeamSelect(props: Props) {
  const { name, optionList, onChange, disabled, required, errorText, ...rest } =
    props
  const {
    initialOption,
    isSubmitting,
    showError,
    helperText,
    height,
    ...restUseData
  } = useData({
    name,
    optionList,
    required,
  })
  const { handelChange } = useHandlers({ name })

  return (
    <Box>
      <Select<SalesTeam>
        {...restUseData}
        {...rest}
        disabled={isSubmitting || disabled}
        onChange={(value) => {
          onChange(value)
          handelChange(value)
        }}
        value={initialOption}
        error={showError}
        required={required !== undefined ? required : true}
        optionMode={'custom'}
        testId="sales-team-select"
        renderOption={(props, team: SalesTeam) => (
          <MenuItem
            sx={{
              height: height,
              minHeight: height,
            }}
            {...props}
            key={team.id}
            value={team.id}
          >
            <Stack>
              <Typography variant="body1">{team.name}</Typography>
              <Typography variant="body2">{team.branchName}</Typography>
            </Stack>
          </MenuItem>
        )}
      />
      {initialOption == null && !(showError || errorText) && (
        <FormHelperText sx={{ ml: 1 }}>
          Select a Sales Team to see the list of Owners.
        </FormHelperText>
      )}
      {(showError || errorText) && (
        <FormHelperText sx={{ ml: 1 }} error>
          {errorText || helperText}
        </FormHelperText>
      )}
    </Box>
  )
}
